module.exports = __webpack_public_path__ + "assets/img/start.a23890b2.svg";